module.exports = __webpack_public_path__ + "img/nomad6.0652d083.jpg";